import {BaseDepartmentId} from "./departments"
import {AdvisorFilter} from "./filter"

export type StudentStaffContact = {
    studentStaffContactId: number
    profileId: number
    contactProfileId: number
    studentStaffContactRoleId: number
    message: string
    isEmergency: boolean
    contactProfile: object
    studentStaffContactRole: object
}

export type ProfileContact = {
    id: number
    relationRole: string
    profileId: number
    contactProfileId: number
    message: string
    isEmergency: boolean
    contactProfile: object
}

export type UserContact = {
    id: number
    userId: number
    contactProfileId: number
    message: string
    isEmergency: boolean
    contactProfile: object
    userPersonalContactRole: object
}

export type ProfileInfo = {
    id: number
    type: string
    isActive: boolean
}
export enum UserContactType {
    staff = "staff",
    personal = "personal"
}

export enum StudentStaffContactRole {
    FinAidAdvisor = 1,
    AdmissionAdvisor = 2,
    AcademicAdvisor = 3,
    StaffContact = 4,
    CampusDirector = 5,
    StudentServicesAdvisor = 6,
    StudentAccountsAdvisor = 7,
    Instructor = 8,
    CareerServicesAdvisor = 9,
    ProgramLead = 10,
    EnrollmentSpecialist = 11,
    FSA = 12
}

export const MAP_DEPARTMENT_ADVISOR_ROLE = {
    [BaseDepartmentId.Academics]: StudentStaffContactRole.AcademicAdvisor,
    [BaseDepartmentId.Admissions]: StudentStaffContactRole.AdmissionAdvisor,
    [BaseDepartmentId.FinancialAid]: StudentStaffContactRole.FinAidAdvisor,
    [BaseDepartmentId.StudentServices]: StudentStaffContactRole.StudentServicesAdvisor,
    [BaseDepartmentId.StudentAccount]: StudentStaffContactRole.StudentAccountsAdvisor,
    [BaseDepartmentId.CareerServices]: StudentStaffContactRole.CareerServicesAdvisor
}

export const MAP_ADVISOR_ROLE_DEPARTMENT = {
    [StudentStaffContactRole.AcademicAdvisor]: BaseDepartmentId.Academics,
    [StudentStaffContactRole.AdmissionAdvisor]: BaseDepartmentId.Admissions,
    [StudentStaffContactRole.FinAidAdvisor]: BaseDepartmentId.FinancialAid,
    [StudentStaffContactRole.StudentServicesAdvisor]: BaseDepartmentId.StudentServices,
    [StudentStaffContactRole.StudentAccountsAdvisor]: BaseDepartmentId.StudentAccount,
    [StudentStaffContactRole.CareerServicesAdvisor]: BaseDepartmentId.CareerServices
}

export const MAP_ADVISOR_ROLE_MODULE_FILTER = {
    [StudentStaffContactRole.AcademicAdvisor]: AdvisorFilter.isAcademicAdvisor,
    [StudentStaffContactRole.AdmissionAdvisor]: AdvisorFilter.isAdmissionsAdvisor,
    [StudentStaffContactRole.FinAidAdvisor]: AdvisorFilter.isFinancialAidAdvisor,
    [StudentStaffContactRole.StudentServicesAdvisor]: AdvisorFilter.isStudentServicesAdvisor,
    [StudentStaffContactRole.StudentAccountsAdvisor]: AdvisorFilter.isStudentAccountAdvisor,
    [StudentStaffContactRole.CareerServicesAdvisor]: AdvisorFilter.isCareerServicesAdvisor
}
